import { CSSProperties } from "react";

export const sharedStyleRules: CSSProperties = {
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
};

export const getStyle = (color: string, pathStyle?: CSSProperties): CSSProperties => {
  return {
    color,
    ...sharedStyleRules,
    ...pathStyle,
  };
}